import { z } from 'zod';

import type { DashboardLogadoBaseParams } from '@/features/performance-dashboard/schemas/dashboard-logado-params';
import {
  dashboardResultsResponseSchema,
  type DashboardResultsResponse,
} from '@/features/performance-dashboard/schemas/dashboardResults';
import { httpGetAdapter } from '@/lib/adapters/httpGetAdapter';

export const getDashboardResultsParamsSchema = z.object({
  anoLetivo: z.number().int().optional(),
  redeId: z.string().optional(),
  escolaId: z.number().int().optional(),
  alunoId: z.number().optional(),
  anoEscolarId: z.number().int().optional(),
  turmaId: z.number().int().optional(),
  categoriaId: z.number().int().optional(),
  nomModelo: z.string(),
});

export type GetDashboardResultsParams = z.infer<typeof getDashboardResultsParamsSchema>;

export const getDashboardResults = httpGetAdapter<DashboardResultsResponse, GetDashboardResultsParams>({
  url: '/v3/dashboard/resultado/header',
  schema: dashboardResultsResponseSchema,
  mapParams: (params) => ({
    anoLetivo: params.anoLetivo,
    redeId: params.redeId,
    escolaId: params.escolaId,
    alunoId: params.alunoId,
    anoEscolarId: params.anoEscolarId,
    turmaId: params.turmaId,
    categoriaId: params.categoriaId,
    nomModelo: params.nomModelo,
  }),
});

export type GetDashboardResultsLogadoParams = DashboardLogadoBaseParams;

export const getDashboardResultsLogado = httpGetAdapter<DashboardResultsResponse, GetDashboardResultsLogadoParams>({
  url: '/v3/dashboard/resultado/header/logado',
  schema: dashboardResultsResponseSchema,
  mapParams: (params) => ({
    anoLetivo: params.anoLetivo,
    categoriaId: params.categoriaId,
    nomModelo: params.nomModelo,
  }),
});

export type GetDashboardResultsByTaskParams = { idTask: number };

export const getDashboardResultsByTask = httpGetAdapter<DashboardResultsResponse, GetDashboardResultsByTaskParams>({
  url: (params) => `/v3/dashboard/resultado/tarefa/${params.idTask}/header`,
  schema: dashboardResultsResponseSchema,
});
